module.exports = __webpack_public_path__ + "static/blm-b3e2c0eb4230bc5c30c111afc4df9330.jpg";